import React from "react";
import SortButton from "../../Component/SortButton/SortButton";
import "../Category/CategoryList.css";

const CategoryListHeader = ({ columnSearch, setColumnSearch, currentSortColumn, currentSortOrder, onSortChange }) => {

  const renderInputColumn = (label, column) => (
    <div>
      <p>{label} <SortButton column={column} currentSortColumn={currentSortColumn} currentSortOrder={currentSortOrder} onSortChange={onSortChange} /></p>
      <input
        type="text"
        placeholder="Search"
        value={columnSearch[column]}
        onChange={(e) => setColumnSearch({ ...columnSearch, [column]: e.target.value })}
      />
    </div>
  );
  const renderDateColumn = (label, column) => (
  <div>
    <p>
      {label}{" "}
      <SortButton
        column={column}
        currentSortColumn={currentSortColumn}
        currentSortOrder={currentSortOrder}
        onSortChange={onSortChange}
      />
    </p>

    <div style={{ height: "32px" }}></div>
  </div>
);

  return (
    <div className="category-grid-row category-grid-header">
      <div>Sr</div>
      <div>Action</div>
      <div>Image</div>

      {renderInputColumn("Category Name", "categoryName")}
      {renderInputColumn("Description", "description")}

      <div>
        <p>Status <SortButton column="status" currentSortColumn={currentSortColumn} currentSortOrder={currentSortOrder} onSortChange={onSortChange} /></p>
        <select
          name="status"
          value={columnSearch.status}
          onChange={(e) => setColumnSearch({ ...columnSearch, status: e.target.value })}
        >
          <option value="Active">Active</option>
          <option value="Deactive">DeActive</option>
        </select>
      </div>

      {renderInputColumn("Company Name", "companyName")}
      {renderInputColumn("Created By", "createdBy")}
      {renderDateColumn("Last Updated", "lastUpdated")}
    </div>
  );
};

export default CategoryListHeader;